"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArtRecordsTemplate = void 0;
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const typedi_1 = require("typedi");
const control_1 = require("@common/form/control");
const ga_1 = require("@common/services/ga");
const translation_1 = require("@translation/services/translation");
const art_records_1 = require("../../service/services/art-records");
/**
 * Всплывающее окно редактирования данных арт-объекта
 */
let ArtRecordsPopup = class ArtRecordsPopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Загрузка
         */
        this.loading = false;
        /**
         * Сохранение
         */
        this.saving = false;
        /**
         * Параметры
         */
        this.params = {};
        /**
         * Форма
         */
        this.form = new control_1.Form({
            objectType: new control_1.TextControl(''),
            title: new control_1.TextControl(''),
            maker: new control_1.TextControl(''),
            dateOrPeriod: new control_1.TextControl(''),
            materialsAndTechniques: new control_1.TextControl(''),
            dimensions: new control_1.TextControl(''),
            inscriptionsAndMarkings: new control_1.TextControl(''),
            features: new control_1.TextControl(''),
            subject: new control_1.TextControl(''),
            reference: new control_1.TextControl(''),
            domain: new control_1.TextControl(''),
        });
        /**
         * Домен
         */
        this.domain = '';
        /**
         * Цена услуги
         */
        this.price = '';
        this.artRecordsService = typedi_1.Container.get(art_records_1.ArtRecordsService);
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.save = this.save.bind(this);
    }
    /**
     * Обрабатывает событие инициализации
     */
    connectedCallback() {
        super.connectedCallback();
        const { price, domain } = this.params;
        this.price = price;
        this.domain = domain;
        this.form.patchValue({ domain: this.domain || '' });
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Генерирует представление
     */
    render() {
        return (0, lit_html_1.html) `
            <style>
                .field-tooltip {
                    margin-top: unset;
                    top: 12px;
                    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAK5SURBVHgBtVXdbdswED5SKtCHoHA3UCaos4E8QGMTTQL4yfYEzQaxJ2gzQeynAi0C2e0AcSaoO0E0goH4TSavdxSpyIotJQ85wD6K5P1990OANyZRd5gkSUvLcACIMQK2BYiI92md0joFIaeBye6VUumrDLBiI8OviHhJny1o8lKI8Zfu58mLDJDyyIjgDgEit7U0qGfviHtPfyZJm1hbiqBLvOcUpRJ1pxqNOKScfimgHp0rtYQa+kEyoZB3DN8+I7J8+Uk5rjaoT5qUM/VJWYjmhDKzYlnWcUMQ+/PQL24Xf64Ic+v5Bk1npNTanzEkBMc3hsVtzQPUE+8p8TVF39kK+ZdAiY5Acu7GBUQMjRbBA68z1Mf9UojujAR3k70Pjl9JEguKgJbrR9LDTlqIMoCYOUWw6FeSpEWYWOWI1yT0kR3wcOjc04IcpPxrHUEw5D1rgMIfWK9kkMAzwjXDdqa6l+wRO5ChUfa+EN3qba44Jxfzv80BJZUqQIAx2b+qwFnvtFPde08ealZGxqtntL+U1mnxqYjAd+iFUitoIEr4UOc4s2eL6rmH2PdRCK+g2/nvBy9oEGcXqjtukpG5NUyZc8XUXTZ8kxJMyRqS8uG+O0ne5bbKmIf5h2BoIgNBTHx6yMB5r3sMDZTxCLFO5wbyCBDuLRcwqBNmiPhXd8fNJy7JaWEgBM0fXBExN8shYTejokPnDmI7/DIa44UBbnVqsmvnwU15lpSJanzE+B9Q3jKuukjXxFeTKF/gWcIlmw+73XlUR/ZhEiEpxzZjf947LXJVTFOOYktK3WvV/kDzp6mqmBhSY2dVrnxL86l8/uzBKc93tzUnWObc5b4R2TDPLzdiYt7zyvt1D86uZ4sxzZoraCabvw2Y7/sgrX30OZrAeermVZR7a2GkhhPLR7OdvTRXb0L/AZtddiMXCqP/AAAAAElFTkSuQmCC');
                }

                .art-records-row div[class^="col"] {
                    position: relative;
                }

                .art-records-row .form-control {
                    padding-right: 45px;
                }

                .field-tooltip.field-tooltip--example {
                    position: relative;
                    top: unset;
                    left: unset;
                    right: unset;
                    display: inline-block;
                    vertical-align: bottom;
                }

                .field-tooltip:hover::after {
                    z-index: 101;
                }
            </style>
            <div class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <div class="modal-header pb-4">
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        
                        <div class="modal-body pt-0">
                            <h2 class="mb-4">${this.translationService.instant('wh_service_artrecords_title_form')} ${this.domain}</h2>

                            <p class="d-none d-sm-inline">
                                ${this.translationService.instant('wh_service_artrecords_subtitle_form')}
                                <span class="field-tooltip field-tooltip--example" data-title="${this.translationService.instant('wh_service_artrecords_subtitle_hint')}"></span>
                            </p>
                            <p class="d-inline d-sm-none">
                                ${this.translationService.instant('wh_service_artrecords_subtitle_form')}
                                ${this.translationService.instant('wh_service_artrecords_subtitle_hint')}
                            </p>
                            
                            <p class="mt-1 mb-4">${this.translationService.instant('wh_service_fee')}: $${Intl.NumberFormat(undefined).format(Number.parseInt(this.price))} (${this.translationService.instant('wh_service_artrecords_fee_desc')})</p>

                            <div class="row art-records-row">
                                <div class="col-12 col-sm-6">
                                    <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('objectType')}" .control="${this.form.get('objectType')}" @enter="${this.save}"></art-text-field>
                                    <span class="field-tooltip" data-title="${this.translationService.instant('hint_type_of_object')}"></span>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('dimensions')}" .control="${this.form.get('dimensions')}" @enter="${this.save}"></art-text-field>
                                    <span class="field-tooltip" data-title="${this.translationService.instant('hint_measurements')}"></span>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('title')}" .control="${this.form.get('title')}" @enter="${this.save}"></art-text-field>
                                    <span class="field-tooltip" data-title="${this.translationService.instant('hint_title')}"></span>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('inscriptionsAndMarkings')}" .control="${this.form.get('inscriptionsAndMarkings')}" @enter="${this.save}"></art-text-field>
                                    <span class="field-tooltip" data-title="${this.translationService.instant('hint_inscriptions_and_markings')}"></span>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('maker')}" .control="${this.form.get('maker')}" @enter="${this.save}"></art-text-field>
                                    <span class="field-tooltip" data-title="${this.translationService.instant('hint_maker')}"></span>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('features')}" .control="${this.form.get('features')}" @enter="${this.save}"></art-text-field>
                                    <span class="field-tooltip" data-title="${this.translationService.instant('hint_features')}"></span>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('dateOrPeriod')}" .control="${this.form.get('dateOrPeriod')}" @enter="${this.save}"></art-text-field>
                                    <span class="field-tooltip" data-title="${this.translationService.instant('hint_date_or_period')}"></span>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('subject')}" .control="${this.form.get('subject')}" @enter="${this.save}"></art-text-field>
                                    <span class="field-tooltip" data-title="${this.translationService.instant('hint_subject')}"></span>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('materialsAndTechniques')}" .control="${this.form.get('materialsAndTechniques')}" @enter="${this.save}"></art-text-field>
                                    <span class="field-tooltip" data-title="${this.translationService.instant('hint_materials_and_techniques')}"></span>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <art-text-field class="d-block mb-5" name="mail" placeholder="${this.translationService.instant('reference')}" .control="${this.form.get('reference')}" @enter="${this.save}"></art-text-field>
                                    <span class="field-tooltip" data-title="${this.translationService.instant('hint_ethereum_blockchain_address')}"></span>
                                </div>
                            </div>
                            
                           <div class="row">
                               <div class="col-6">
                                   <button class="btn btn-secondary w-100" data-bs-dismiss="modal" ?disabled="${this.saving}">${this.translationService.instant('cancel')}</button>
                               </div>
                               <div class="col-6">
                                   <button class="btn btn-primary w-100" @click="${this.save}" ?disabled="${this.saving}">${this.translationService.instant('supportticketsticketsubmit')}</button>
                               </div>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    /**
     * Сохраняет данные
     */
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            this.saving = true;
            try {
                const result = yield this.artRecordsService.save(this.form.getValue());
                const ga = result.data.ga;
                const gaService = new ga_1.GaService();
                gaService.pushGA(ga);
                window.location.reload();
            }
            catch (err) {
                if (err.errors) {
                    this.form.setErrors(err.errors);
                }
            }
            finally {
                this.saving = false;
            }
        });
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], ArtRecordsPopup.prototype, "loading", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], ArtRecordsPopup.prototype, "saving", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Object)
], ArtRecordsPopup.prototype, "params", void 0);
ArtRecordsPopup = __decorate([
    (0, decorators_js_1.customElement)('art-art-records-popup'),
    __metadata("design:paramtypes", [])
], ArtRecordsPopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getArtRecordsTemplate(params) {
    return (0, lit_html_1.html) `<art-art-records-popup .params="${params}"></art-art-records-popup>`;
}
exports.getArtRecordsTemplate = getArtRecordsTemplate;
window.PopupController.registerTemplate('art-records', getArtRecordsTemplate);
